import developmentlogEdit from './edit.vue'
import developmentlogList from './list.vue'
import developmentlogindex from './index.vue'


let a = Object.assign({ developmentlogEdit, developmentlogList,developmentlogindex})
export default a
